import * as Cookies from "js-cookie";

export const setCookie = (name, value, options) => {
  if (name && value && options) {
    Cookies.set(name, value, options);
    return;
  }

  if (name && value) {
    Cookies.set(name, value, { domain: "ct.gov", path: "/", secure: true, sameSite: "None" });
  }
};

export const getCookies = (name) => {
  if (name) {
    return Cookies.get(name);
  }

  return Cookies.get();
};

export const removeCookie = (name, options) => {
  if (name && options) {
    Cookies.remove(name, options);
    return;
  }

  if (name) {
    Cookies.remove(name, { domain: "ct.gov", path: "/" });
  }
};
